import { publishConstant } from '../constants';

export const publish = (state = {
    searchResult: [],
    filters:null
}, action) => {
    switch (action.type) {
        case publishConstant.SEARCH_QUESTION_SUCCESS:
            return {
                ...state,
                searchResult: action.payload.questions
            }
        case publishConstant.FILTERS:
            return {
                ...state,
                filters:action.payload.data
            }
        case publishConstant.SELECTED_FILTERS:
            return { 
                ...state,
                selectedFilter: action.payload
            }
        case publishConstant.FETCH_SOLUTION_TEXT:
            return {
                ...state,
                solutionText: action.payload.solutionText
            }
        default:
            return state
    }
}